import { render, staticRenderFns } from "./SharedData.vue?vue&type=template&id=74f06d28&scoped=true"
import script from "./SharedData.vue?vue&type=script&lang=js"
export * from "./SharedData.vue?vue&type=script&lang=js"
import style0 from "./SharedData.vue?vue&type=style&index=0&id=74f06d28&prod&scoped=true&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "74f06d28",
  null
  
)

export default component.exports